var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayersVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5688 4.7192L4 10.2311L10.2507 12.5751C10.8876 12.8139 11.2061 12.9334 11.5255 12.9467C11.8082 12.9585 12.0901 12.9102 12.3527 12.805C12.6495 12.6861 12.9101 12.4674 13.4312 12.0302L20 6.5183L13.7493 4.17429C13.1124 3.93544 12.7939 3.81602 12.4745 3.80269C12.1918 3.7909 11.9099 3.8392 11.6473 3.94441C11.3505 4.06333 11.0899 4.28195 10.5688 4.7192L10.5688 4.7192Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.0995L13.4312 20.6114C12.9101 21.0486 12.6495 21.2672 12.3527 21.3862C12.0901 21.4914 11.8082 21.5397 11.5255 21.5279C11.2061 21.5145 10.8876 21.3951 10.2507 21.1563L4 18.8123",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.8089L13.4312 16.3208C12.9101 16.758 12.6495 16.9766 12.3527 17.0956C12.0901 17.2008 11.8082 17.2491 11.5255 17.2373C11.2061 17.224 10.8876 17.1045 10.2507 16.8657L4 14.5217",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersVector);
export default __webpack_public_path__ + "static/media/LayersVector.e217c4612d7dca9c549ff94d90c8f9de.svg";
export { ForwardRef as ReactComponent };